import classNames from "classnames";
import React from "react";

import type { IBaseComponent } from "../models/formFields";
import { FormHelpText } from "./FormHelpText";
import { FormTooltip } from "./FormTooltip";
import { FormValidationError } from "./FormValidationError";
import { FormWarning } from "./FormWarning";
import { showValidationErrors } from "./hooks/formUtils";

/**
 * Wrapper component for form fields (replaces AbstractFormComponent render)
 */
export const FormFieldWrapper = (
    props: React.PropsWithChildren<
        IBaseComponent & {
            name?: string;
        }
    >,
): React.ReactNode => {
    const classes = classNames({
        "form__field": true,
        [`form__field--${props.name}`]: !!props.name,
        "form__field--has-errors": showValidationErrors(props),
    });

    return (
        <div className={classes}>
            <FormTooltip
                tooltipText={props.tooltipText}
                tooltipLink={props.tooltipLink}
                tooltipClass={props.tooltipClass}
            />
            {props.children}
            <FormValidationError {...props} id={props.id} />
            <FormHelpText
                id={props.id}
                helpText={props.helpText}
                helpTextClass={props.helpTextClass}
            />
            <FormWarning
                warningTitle={props.warningTitle}
                warningText={props.warningText}
            />
        </div>
    );
};
